export default __webpack_public_path__ + "static/media/dra-isabela.ad379e81.png";